import { Theme } from '@mui/material';
import { Colors } from '../../constants/colors.constants';

export const orderSummaryStyles = (theme?: Theme) => ({
	grid: {
		display: 'grid',
		gridTemplateColumns: '4fr 0.8fr 1.4fr',
		gridColumnGap: '8px',
	},
	title: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '20px',
		lineHeight: '24px',
		fontWeight: 500,
		p: { xs: '16px 16px 20px 16px', sm: '12px 24px 20px 24px' },
		color: '#FFFFFF',
		borderBottom: '2px solid #FFFFFF0D',
	},
	membershipName: {
		color: '#FFFFFF',
		width: 'fit-content',
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '124%',
		maxWidth: '100%',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
	},
	membershipMonthlyPrice: {
		color: Colors.white_a60,
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '12px',
		fontWeight: 500,
	},
	membershipPeriod: {
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '12px',
		fontWeight: 500,
		color: Colors.white_a60,
	},
	tierFrequency: {
		color: Colors.white,
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '15px',
		fontWeight: 500,
		lineHeight: '100%',
	},
	tierName: {
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '17px',
		color: '#FFFFFF',
		flex: 1,
	},
	tierQuantity: {
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '15px',
		fontWeight: 500,
		lineHeight: '18px',
		color: '#FFFFFF',
	},
	price: {
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '15px',
		fontWeight: 500,
		lineHeight: '18px',
		color: '#FFFFFF',
	},
	textNormal: {
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '17px',
		color: '#FFFFFF',
	},
	textStriked: {
		fontFamily: 'Integral CF',
		fontSize: '16px',
		fontWeight: 400,
		lineHeight: '19px',
		color: '#FFFFFF66',
		textDecoration: 'line-through',
		textDecorationColor: 'currentColor',
	},
	textBigger: {
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '14px',
		lineHeight: '17px',
		fontWeight: 700,
		color: '#FFFFFF',
	},
	totalPrice: {
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '16px',
		lineHeight: '20px',
		fontWeight: 600,
		color: '#FFFFFF',
	},
	discountBox: {
		flexDirection: { xs: 'column', md: 'row' },
	},
	discountField: {
		height: '45px',
		flexGrow: 1,

		'& .MuiInputBase-input': {
			height: 'auto',
			backgroundColor: '#FFFFFF0D',
			color: '#FFFFFF',
			borderRadius: '100px',
			p: '14px 21px',
			fontFamily: 'Montserrat, sans-serif',
			fontSize: '16px',
			fontWeight: 500,
			lineHeight: '17px',
		},

		fieldset: {
			borderRadius: '100px',
		},
	},
	applyButton: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '12px',
		fontWeight: 500,
		lineHeight: '14px',
		color: '#000000',
		px: '35px',
		py: '16px',
		borderRadius: '100px',
		background: '#FFFFFF',
		border: '1px solid transparent',

		'&:hover': {
			color: '#FFFFFF',
			background: '#000000',
			border: '1px solid #120E0D',
		},

		'&:active': {
			color: '#FFFFFF',
			background: '#000000',
		},
	},
	totalDiscountHint: {
		color: '#FFFFFF',
		fontFamily: 'Montserrat, sans-serif',
		lineHeight: '19px',
		fontWeight: 600,
	},
	refundBox: {
		color: '#C6C6C6',
		p: { xs: '14px 16px 0 16px', sm: '14px 24px 0 24px' },
		display: 'flex',
		justifyContent: 'column',
		gap: '4px',
		borderTop: '2px solid #FFFFFF0D',
	},
	footer: {
		p: '12px',
		backgroundColor: '#00000080',
		display: 'flex',
		justifyContent: 'center',
	},
});
